import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/DbosConductorPage.head';
import { DbosConductorPage } from '@pages/DbosConductorPage';

export const Route = createFileRoute('/dbos-conductor')({
  component: DbosConductorPage,
  head: () => head,
});
